module.exports = __webpack_public_path__ + "static/media/Seismitoad_gaussian2.764222d7.png";